
import {tracs_api} from "../../services/api.interceptor";

class UserService {
  isCubicUser(){
    return tracs_api.get(process.env.REACT_APP_USER_API +"User/IsCubicUser");
  } 
  createuser(username: string, fullname: string, email: string, roleid: number, tocid: number | null) {
    return  tracs_api
      .post(process.env.REACT_APP_USER_API + "User/Create", {
        UserName: username,
        FullName: fullname,
        Email: email,
        RoleId: roleid,
        TocId: tocid
      });
  }

  getusermenu() {
    return tracs_api.post(process.env.REACT_APP_USER_API + "User/GetMenu");
  }

  getusers(includeInactive: boolean) {
    return tracs_api.post(process.env.REACT_APP_USER_API + "User/GetUsers", { IncludeInactive: includeInactive });
  }

  deleteuser(id:number){
    return tracs_api.post(process.env.REACT_APP_USER_API + "User/DeleteUser", { Id:id})
  }

getroles() {
    return tracs_api.post(process.env.REACT_APP_USER_API + "User/GetRoles");
  }

  changepassword(password: string, newpassword: string) {
    return  tracs_api
      .post(process.env.REACT_APP_USER_API + "User/ChangePassword", {
        Password: password,
        NewPassword: newpassword
       
      }).catch(error => {
        //errorCallback(error.response.data);
       
      });
      
  }
  
  // UpdateLastLoginDate() {
  //   return tracs_api
  //     .post(process.env.REACT_APP_USER_API + "User/UpdateLastLoginDate")
  //     .then(response => {
       
        
  //     }).catch(error => {
  //       //errorCallback(error.response.data);
       
  //     });
  // }

}

export default new UserService();